import React from 'react';

import color from 'src/styles/themes/color';

type Props = {
  w?: number;
  h?: number;
  fill?: string;
  className?: string;
  onClick?: () => void;
};

const Info: React.FC<Props> = ({
  w = 14,
  h = 14,
  fill = color.primary_color,
  className,
  onClick,
}) => {
  return (
    <svg
      width={w}
      height={h}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <path
        d="M7 0.875C3.61758 0.875 0.875 3.61758 0.875 7C0.875 10.3824 3.61758 13.125 7 13.125C10.3824 13.125 13.125 10.3824 13.125 7C13.125 3.61758 10.3824 0.875 7 0.875ZM7 12.0859C4.1918 12.0859 1.91406 9.8082 1.91406 7C1.91406 4.1918 4.1918 1.91406 7 1.91406C9.8082 1.91406 12.0859 4.1918 12.0859 7C12.0859 9.8082 9.8082 12.0859 7 12.0859Z"
        fill={fill}
      />
      <path
        d="M6.34354 9.40625C6.34354 9.5803 6.41268 9.74722 6.53575 9.87029C6.65882 9.99336 6.82574 10.0625 6.99979 10.0625C7.17383 10.0625 7.34075 9.99336 7.46382 9.87029C7.5869 9.74722 7.65604 9.5803 7.65604 9.40625C7.65604 9.2322 7.5869 9.06528 7.46382 8.94221C7.34075 8.81914 7.17383 8.75 6.99979 8.75C6.82574 8.75 6.65882 8.81914 6.53575 8.94221C6.41268 9.06528 6.34354 9.2322 6.34354 9.40625ZM6.67166 7.875H7.32791C7.38807 7.875 7.43729 7.82578 7.43729 7.76563V4.04688C7.43729 3.98672 7.38807 3.9375 7.32791 3.9375H6.67166C6.61151 3.9375 6.56229 3.98672 6.56229 4.04688V7.76563C6.56229 7.82578 6.61151 7.875 6.67166 7.875Z"
        fill={fill}
      />
    </svg>
  );
};

export default Info;
